import { render, staticRenderFns } from "./activity-version-modal.vue?vue&type=template&id=696727ee&scoped=true&"
import script from "./activity-version-modal.vue?vue&type=script&lang=js&"
export * from "./activity-version-modal.vue?vue&type=script&lang=js&"
import style0 from "./activity-version-modal.vue?vue&type=style&index=0&id=696727ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "696727ee",
  null
  
)

component.options.__file = "activity-version-modal.vue"
export default component.exports